import { z } from 'zod';
import { baseObjectSchema } from '../baseSchemas';
import { userSchema } from '../user/getUsers';
import { getQuestionSchema } from './getQuestions';

export const getQuestionnaireSchema = baseObjectSchema.extend({
  title: z.string(),
  description: z.string(),
  bindingType: z.number(),
  effectiveFromDate: z.string(),
  effectiveUpToDate: z.string(),
  sequence: z.number(),
  mwQuestionnaireType: z.string(),
  listColumns: z.number(),
  isStandards: z.boolean(),
  traderGroupId: z.string(),
  assortmentId: z.string().optional(),
  traderGroup: z.string(),
  assortment: z.string().optional(),
  actionId: z.string().optional(),
  action: z
    .object({
      id: z.string(),
      description: z.string(),
    })
    .optional(),
  questions: z.array(getQuestionSchema).optional(),
  createUser: userSchema.optional(),
  updateUser: userSchema.optional(),
  bindingId: z.string().optional(),
  groupItem: z.string().optional(),
});
export const getQuestionnairesSchema = z.array(getQuestionnaireSchema);
export type GetQuestionnairesResponse = z.infer<typeof getQuestionnairesSchema>;
export type GetQuestionnaireResponse = z.infer<typeof getQuestionnaireSchema>;
